export default {
	data() {
		return {
			isOpenModalNovaTarefa: false,
			notificacaoEventoSelecionada: null,
		}
	},

	methods: {
		onClickAddTask(notificacao) {
			this.notificacaoEventoSelecionada = notificacao
			this.openModalNovaTarefa(notificacao)
		},
		openModalNovaTarefa(notificacao) {
			this.isOpenModalNovaTarefa = true
		},
		closeModalNovaTarefa() {
			this.isOpenModalNovaTarefa = false
		},
	},
}
